import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';

export function RodapeInstitucional() {
  return (
    <footer
      style={{
        borderTop: '1px solid var(--cor-borda)',
        marginTop: '48px',
        padding: '32px 0',
        background: 'var(--cor-branco)',
      }}
    >
      <Container
        style={{
          maxWidth: '1140px',
          display: 'flex',
          flexWrap: 'wrap',
          gap: '16px',
          justifyContent: 'space-between',
          fontSize: '13px',
          color: 'var(--cor-texto)',
        }}
      >
        <div>
          <p style={{ margin: '0 0 4px' }}>
            <strong>Lizzi Food</strong> — sistema de gestão para restaurantes
          </p>
          <p style={{ margin: 0 }}>CNPJ: 58.030.824/0001-94</p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
          <Link to="/politica-de-privacidade" style={{ color: 'var(--cor-primaria)' }}>
            Política de Privacidade
          </Link>
          <Link to="/termos-de-uso" style={{ color: 'var(--cor-primaria)' }}>
            Termos e Condições de Contrato
          </Link>
        </div>
        <p style={{ margin: 0 }}>© {new Date().getFullYear()} Lizzi Food. Todos os direitos reservados.</p>
      </Container>
    </footer>
  );
}
